import { render, staticRenderFns } from "./PollResultsTable.vue?vue&type=template&id=3c5b579c&scoped=true&"
import script from "./PollResultsTable.vue?vue&type=script&lang=js&"
export * from "./PollResultsTable.vue?vue&type=script&lang=js&"
import style0 from "./PollResultsTable.vue?vue&type=style&index=0&id=3c5b579c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5b579c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VIcon})
